import { NgModule } from '@angular/core';
import { StepHeaderComponent } from 'components/modal-windows/step-details/header/step-header.component';
import { StepDetailHeaderIconModule } from 'components/certificate/step-details-header-icon/step-detail-header-icon.module';
import { CertemyCommonModule } from 'common/certemy-common.module';
import { IconModule } from '@certemy/ui-components';

@NgModule({
  imports: [StepDetailHeaderIconModule, CertemyCommonModule, IconModule],
  exports: [StepHeaderComponent],
  declarations: [StepHeaderComponent],
  providers: [],
})
export class StepHeaderModule {}
